//   ####    ###    ###    ###  #####   ##      #####
//  ##      ## ##   ## #  # ##  ##  ##  ##      ##
//   ###   ##   ##  ##  ##  ##  #####   ##      #####
//     ##  #######  ##      ##  ##      ##      ##
//  ####   ##   ##  ##      ##  ##      ######  #####

if (location.hash === '#--sample-alert-1') {
  const sampleDOM = document.createElement('div')
  sampleDOM.innerHTML = '下書き保存が完了いたしました。<br>公開はまだされていません'
  sampleDOM.setAttribute('class', 'js-popAlert popAlert')
  const sampleDOMTarget = document.body
  sampleDOMTarget.appendChild(sampleDOM) // 最後の子要素として追加
} else if (location.hash === '#--sample-alert-2') {
  const sampleDOM = document.createElement('div')
  sampleDOM.innerHTML = '公開しました'
  sampleDOM.setAttribute('class', 'js-popAlert popAlert')
  const sampleDOMTarget = document.body
  sampleDOMTarget.appendChild(sampleDOM) // 最後の子要素として追加
} else if (location.hash === '#--sample-alert-3') {
  const sampleDOM = document.createElement('div')
  sampleDOM.innerHTML = 'ページを非公開にしました'
  sampleDOM.setAttribute('class', 'js-popAlert popAlert')
  const sampleDOMTarget = document.body
  sampleDOMTarget.appendChild(sampleDOM) // 最後の子要素として追加
}

//  ######  ##  ###    ###  #####  #####
//    ##    ##  ## #  # ##  ##     ##  ##
//    ##    ##  ##  ##  ##  #####  #####
//    ##    ##  ##      ##  ##     ##  ##
//    ##    ##  ##      ##  #####  ##   ##
// 時間経過でポップアップを消す
setTimeout(() => {
  const popList = document.getElementsByClassName('js-popAlert')
  if (popList[0]) {
    for (const pop of popList) {
      pop.classList.add('hide')
    }
  }
}, 4000)
